module.exports = __webpack_public_path__ + "img/06.ed5432a7.png";